import APIBase from "./apiBase";

export interface QueuedDeletion {
  id: string;
  resourceType: "user" | "inbox";
  resourceId: string;
  resourceName: string;
  resourceEmail: string;
  scheduledFor: string;
  executedAt: string | null;
  status: "scheduled" | "executed" | "failed";
  result: string | null;
  createdAt: string;
}

export interface DeletionResult {
  message: string;
  scheduledFor?: string;
  queuedDeletion: QueuedDeletion;
  deletedImmediately?: boolean;
}

export interface ProcessOverdueResult {
  message: string;
  processedCount: number;
  failedCount: number;
}

// Delete user
export const deleteUser = async (
  userId: string,
  immediate: boolean = false
): Promise<DeletionResult> => {
  const { data } = await APIBase.delete<DeletionResult>(`/users/${userId}`, {
    data: { immediate },
  });
  return data;
};

// Delete inbox
export const deleteInbox = async (
  inboxId: string,
  immediate: boolean = false
): Promise<DeletionResult> => {
  const { data } = await APIBase.delete<DeletionResult>(`/inboxes/${inboxId}`, {
    data: { immediate },
  });
  return data;
};

// List all queued deletions (superadmin only)
export const listQueuedDeletions = async (): Promise<QueuedDeletion[]> => {
  const { data } = await APIBase.get<QueuedDeletion[]>("/deletions");
  return data;
};

// Get a specific queued deletion (superadmin only)
export const getQueuedDeletion = async (
  deletionId: string
): Promise<QueuedDeletion> => {
  const { data } = await APIBase.get<QueuedDeletion>(
    `/deletions/${deletionId}`
  );
  return data;
};

// Execute a scheduled deletion immediately (superadmin only)
export const executeDeletion = async (
  deletionId: string
): Promise<{ message: string }> => {
  const { data } = await APIBase.post<{ message: string }>(
    `/deletions/${deletionId}/execute`
  );
  return data;
};

// Process all overdue deletions manually (superadmin only)
export const processOverdueDeletions =
  async (): Promise<ProcessOverdueResult> => {
    const { data } = await APIBase.post<ProcessOverdueResult>(
      "/deletions/process-overdue"
    );
    return data;
  };
